import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import LocalidadEntregaListado from '../../components/LocalidadEntrega/localidadEntregaList';
import { sagaGetLocalidadesEntrega, saveLocalidadEntrega, sagaEliminarLocalidadEntrega, sagaGetLocalidadEntregaByNombre } from '../../reducers/localidadesEntregaReducer/actions';
import { localidadesEntregaDataSelector } from '../../selectors/localidadesEntregaSelector';
import { usuarioSelector } from '../../selectors/sessionSelector';
import * as Notification from '../../components/Common/notification';

class LocalidadEntregaContainer extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            nombreLocalidad: "",
            localidades: [],
            allLocalidades: [],
            modalData: {
                openModal: false,
                mensaje: "Está por eliminar una localidad de entrega",
                labelModalOk: "Eliminar",
                handleModalOk: () => {},
                handleCloseModal: () => {},
            },
            usuarioCargado: false
        }
        // busco los datos iniciales
        this.busqueda()
    }

    componentDidUpdate = (prevProps) => {
        if (this.state.usuarioCargado === false && this.props.usuario !== undefined) {
            this.setState({ usuarioCargado: true }, () => {
                if (this.props.usuario.idRol === 4) {
                    window.location.hash = '/Pedidos'
                }
            })
        }

        if (prevProps.localidades.localidades !== this.props.localidades.localidades) {
            this.setState({ 
                allLocalidades: this.props.localidades.localidades,
                localidades: this.props.localidades.localidades
            });
        }
    }

    busqueda() {
        this.props.sagaGetLocalidadesEntrega(this.state.nombreLocalidad);
        this.props.saveLocalidadEntrega(undefined);
    }

    handleSearch = (nombreLocalidad) => {
        if (!nombreLocalidad || nombreLocalidad.trim() === "") {
            this.setState({ localidades: this.state.allLocalidades });
        } else {
            const filteredLocalidades = this.state.allLocalidades.filter(localidad =>
                localidad.nombre.toLowerCase().includes(nombreLocalidad.toLowerCase())
            );
            this.setState({ nombreLocalidad, localidades: filteredLocalidades });
        }
    }

    setModalData = (localidad) => {
        this.setState({
            modalData: {
                openModal: true,
                mensaje: `Está por eliminar la localidad de entrega ${localidad.descripcion}`,
                labelModalOk: "Eliminar",
                handleModalOk: () => {
                    this.props.sagaEliminarLocalidadEntrega(localidad.idLocalidadEntrega);
                    this.setState({ modalData: { openModal: false } });
                },
                handleCloseModal: () => {
                    this.setState({ modalData: { openModal: false } });
                },
            }
        });
    }

    render() {
        return <>
            <LocalidadEntregaListado 
                localidades={this.state.localidades}
                mapToItem={(x) => ({
                    nombre: x.nombre,
                    descripcion: x.descripcion,
                    estado: x.estado,
                    onClick: x ? () => { 
                        this.props.saveLocalidadEntrega(x); 
                        this.props.history.push("/LocalidadesEntrega/Edit/" + x.idLocalidadEntrega) 
                    } : undefined,
                    opciones: x ? [
                        { 
                            nombre: "Editar", 
                            handler: () => { 
                                this.props.saveLocalidadEntrega(x); 
                                this.props.history.push("/LocalidadesEntrega/Edit/" + x.idLocalidadEntrega) 
                            } 
                        },
                        { 
                            nombre: "Eliminar", 
                            handler: () => { 
                                this.setModalData(x);
                            }
                        }
                    ] : []
                })}
                handleOnSave={() => {}}
                handleOnSearch={this.handleSearch}
                {...this.state.modalData}
            />
        </>
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        sagaGetLocalidadesEntrega,
        saveLocalidadEntrega,
        sagaEliminarLocalidadEntrega,
        sagaGetLocalidadEntregaByNombre
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        localidades: localidadesEntregaDataSelector(state),
        usuario: usuarioSelector(state)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LocalidadEntregaContainer);